exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-6b1a75ee]{width:80%}.content .selfInput[data-v-6b1a75ee] .el-input-group__append{border:0;background-color:#fff;color:#000}.content .inputWidth[data-v-6b1a75ee]{width:380px}.content .item[data-v-6b1a75ee]{margin-right:30px}.content[data-v-6b1a75ee] .el-input-number .el-input__inner{text-align:left}\n", ""]);

// exports
